<template>
  <v-menu v-if="changeReservationStateFlag" offset-y :disabled="isBreakTime">
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" :class="chipColor" dark>{{ chipName }}</v-chip>
    </template>
    <v-list flat>
      <v-list-item
        v-if="reservationState === 'rs_complete'"
        active-class="border"
        @click="onChangeReservationState('rs_receipt')"
      >
        <v-icon color="dark3Grey">update</v-icon>
        <v-list-item-title class="pl-1"> 배차 취소</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="reservationState === 'rs_cancel'"
        active-class="border"
        @click="onChangeReservationState('rs_user_cancel')"
      >
        <v-icon color="dark3Grey"> close</v-icon>
        <v-list-item-title class="pl-1"> 무단 취소</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="reservationState === 'rs_user_cancel'"
        active-class="border"
        @click="onChangeReservationState('rs_cancel')"
      >
        <v-icon color="dark3Grey"> close</v-icon>
        <v-list-item-title class="pl-1"> 정상 취소</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-menu v-else offset-y>
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" :class="chipColor" dark>{{ chipName }}</v-chip>
    </template>
    <v-list
      v-if="reservationState === 'rs_receipt' && reservationStateEventFlag"
      flat
    >
      <v-list-item active-class="border" @click="onReReservation('auto')">
        <v-icon color="dark3Grey">update</v-icon>
        <v-list-item-title class="pl-1"> 자동배차</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="border" @click="onReReservation('manual')">
        <v-icon color="dark3Grey"> update</v-icon>
        <v-list-item-title class="pl-1"> 수동배차</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: "CReservationStateChip",
  props: {
    reservation: {
      type: Object,
    },
    reservationStateEventFlag: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    status() {
      if (this.reservation)
        return (
          this.reservation.state ||
          this.reservation.resrvState ||
          this.reservation.status
        );
      else return null;
    },
    reservationState() {
      if (this.status) return this.status.configValue;
      else return null;
    },
    chipColor() {
      if (this.reservationState === "rs_complete") {
        return "light1Green";
      } else if (this.reservationState === "rs_driving") {
        return "blue";
      } else if (this.reservationState === "rs_done") {
        return "light2Blue";
      } else if (this.reservationState === "rs_cancel") {
        return "light2Grey";
      } else if (this.reservationState === "rs_receipt") {
        return "light1Red";
      } else if (this.reservationState === "rs_user_cancel") {
        return "red";
      } else {
        return "red";
      }
    },
    chipName() {
      if (!this.reservation) return "";

      return this.status.configName;
    },
    isBreakTime() {
      return (
        this.reservation &&
        this.reservation.departure === "휴식" &&
        this.reservation.destination === "휴식"
      );
    },
    changeReservationStateFlag() {
      return (
        this.reservationStateEventFlag &&
        this.reservation &&
        (this.reservationState === "rs_complete" ||
          this.reservationState === "rs_cancel" ||
          this.reservationState === "rs_user_cancel")
      );
    },
  },
  methods: {
    onChangeReservationState(state) {
      this.$emit("onChangeReservationState", state, this.reservation);
    },
    onReReservation(type) {
      this.$emit("onReReservation", type, this.reservation);
    },
  },
};
</script>
